module.exports = __webpack_public_path__ + "static/media/cableimg2.ba71aefd.png";